import {
  DEFAULT_ADVANCED_CHOICE_KEY,
  resolveAwardedCardIds,
  type AdvancedChoiceKey,
  type AwardedCardId,
  type ChoiceKey,
} from '@ark/nup-shared';
import choiceConfirmNvidiaImg from '../assets/rewards/choice-confirm-nvidia.png';
import choiceConfirmBtcImg from '../assets/rewards/choice-confirm-btc.png';
import choiceConfirmVoucherImg from '../assets/rewards/choice-confirm-voucher.png';
import choiceConfirmHsbcImg from '../assets/rewards/choice-confirm-hsbc.png';
import choiceWideNvidiaImg from '../assets/rewards/choice-wide-nvidia.png';
import choiceWideBtcImg from '../assets/rewards/choice-wide-btc.png';
import choiceWideVoucherImg from '../assets/rewards/choice-wide-voucher.png';
import choiceWideHsbcImg from '../assets/rewards/choice-wide-hsbc.png';
import awardedNvidiaImg from '../assets/rewards/awarded-nvidia.png';
import awardedBtcImg from '../assets/rewards/awarded-btc.png';
import awardedVoucherImg from '../assets/rewards/awarded-voucher.png';
import awardedHsbcImg from '../assets/rewards/awarded-hsbc.png';
import awardedAdvancedNvidiaImg from '../assets/rewards/awarded-advanced-nvidia.png';
import awardedAdvancedBtcImg from '../assets/rewards/awarded-advanced-btc.png';
import awardedAdvancedHsbcImg from '../assets/rewards/awarded-advanced-hsbc.png';
import awarded2000Img from '../assets/rewards/awarded-2000.png';
import awarded4000Img from '../assets/rewards/awarded-4000.png';
import awarded8000Img from '../assets/rewards/awarded-8000.png';
import awarded35000Img from '../assets/rewards/awarded-35000.png';
import awarded65000Img from '../assets/rewards/awarded-65000.png';
import awarded100000Img from '../assets/rewards/awarded-100000.png';
import awardedMissedImg from '../assets/rewards/awarded-missed.png';
import voucher2000Img from '../assets/rewards/voucher-2000.png';
import voucher4000Img from '../assets/rewards/voucher-4000.png';
import voucher8000Img from '../assets/rewards/voucher-8000.png';
import voucher35000Img from '../assets/rewards/voucher-35000.png';
import voucher65000Img from '../assets/rewards/voucher-65000.png';
import voucher1000000Img from '../assets/rewards/voucher-1000000.png';
import pcVoucher2000Img from '../assets/rewards/pc-voucher-2000.png';
import pcVoucher4000Img from '../assets/rewards/pc-voucher-4000.png';
import pcVoucher8000Img from '../assets/rewards/pc-voucher-8000.png';
import pcVoucher35000Img from '../assets/rewards/pc-voucher-35000.png';
import pcVoucher65000Img from '../assets/rewards/pc-voucher-65000.png';
import pcVoucher100000Img from '../assets/rewards/pc-voucher-100000.png';
import pcAwardedNvidiaImg from '../assets/rewards/pc-awarded-nvidia.png';
import pcAwardedBtcImg from '../assets/rewards/pc-awarded-btc.png';
import pcAwardedVoucherImg from '../assets/rewards/pc-awarded-voucher.png';
import pcAwardedHsbcImg from '../assets/rewards/pc-awarded-hsbc.png';
import pcAwardedAdvancedNvidiaImg from '../assets/rewards/pc-awarded-advanced-nvidia.png';
import pcAwardedAdvancedBtcImg from '../assets/rewards/pc-awarded-advanced-btc.png';
import pcAwardedAdvancedHsbcImg from '../assets/rewards/pc-awarded-advanced-hsbc.png';
import pcAwarded2000Img from '../assets/rewards/pc-awarded-2000.png';
import pcAwarded4000Img from '../assets/rewards/pc-awarded-4000.png';
import pcAwarded8000Img from '../assets/rewards/pc-awarded-8000.png';
import pcAwarded35000Img from '../assets/rewards/pc-awarded-35000.png';
import pcAwarded65000Img from '../assets/rewards/pc-awarded-65000.png';
import pcAwarded100000Img from '../assets/rewards/pc-awarded-100000.png';
import pcAwardedMissedImg from '../assets/rewards/pc-awarded-missed.png';
import enChoiceConfirmNvidiaImg from '../assets/en/choice-confirm-nvidia.png';
import enChoiceConfirmBtcImg from '../assets/en/choice-confirm-btc.png';
import enChoiceConfirmVoucherImg from '../assets/en/choice-confirm-voucher.png';
import enChoiceConfirmHsbcImg from '../assets/en/choice-confirm-hsbc.png';
import enChoiceWideNvidiaImg from '../assets/en/choice-wide-nvidia.png';
import enChoiceWideBtcImg from '../assets/en/choice-wide-btc.png';
import enChoiceWideVoucherImg from '../assets/en/choice-wide-voucher.png';
import enChoiceWideHsbcImg from '../assets/en/choice-wide-hsbc.png';
import enAwardedNvidiaImg from '../assets/en/awarded-nvidia.png';
import enAwardedBtcImg from '../assets/en/awarded-btc.png';
import enAwardedVoucherImg from '../assets/en/awarded-voucher.png';
import enAwardedHsbcImg from '../assets/en/awarded-hsbc.png';
import enAwardedAdvancedNvidiaImg from '../assets/en/awarded-advanced-nvidia.png';
import enAwardedAdvancedBtcImg from '../assets/en/awarded-advanced-btc.png';
import enAwardedAdvancedHsbcImg from '../assets/en/awarded-advanced-hsbc.png';
import enAwarded2000Img from '../assets/en/awarded-2000.png';
import enAwarded4000Img from '../assets/en/awarded-4000.png';
import enAwarded8000Img from '../assets/en/awarded-8000.png';
import enAwarded35000Img from '../assets/en/awarded-35000.png';
import enAwarded65000Img from '../assets/en/awarded-65000.png';
import enAwarded100000Img from '../assets/en/awarded-100000.png';
import enVoucher2000Img from '../assets/en/voucher-2000.png';
import enVoucher4000Img from '../assets/en/voucher-4000.png';
import enVoucher8000Img from '../assets/en/voucher-8000.png';
import enVoucher35000Img from '../assets/en/voucher-35000.png';
import enVoucher65000Img from '../assets/en/voucher-65000.png';
import enVoucher1000000Img from '../assets/en/voucher-1000000.png';
import enPcVoucher2000Img from '../assets/en/pc-voucher-2000.png';
import enPcVoucher4000Img from '../assets/en/pc-voucher-4000.png';
import enPcVoucher8000Img from '../assets/en/pc-voucher-8000.png';
import enPcVoucher35000Img from '../assets/en/pc-voucher-35000.png';
import enPcVoucher65000Img from '../assets/en/pc-voucher-65000.png';
import enPcVoucher100000Img from '../assets/en/pc-voucher-100000.png';
import enPcAwardedNvidiaImg from '../assets/en/pc-awarded-nvidia.png';
import enPcAwardedBtcImg from '../assets/en/pc-awarded-btc.png';
import enPcAwardedVoucherImg from '../assets/en/pc-awarded-voucher.png';
import enPcAwardedHsbcImg from '../assets/en/pc-awarded-hsbc.png';
import enPcAwardedAdvancedNvidiaImg from '../assets/en/pc-awarded-advanced-nvidia.png';
import enPcAwardedAdvancedBtcImg from '../assets/en/pc-awarded-advanced-btc.png';
import enPcAwardedAdvancedHsbcImg from '../assets/en/pc-awarded-advanced-hsbc.png';
import enPcAwarded2000Img from '../assets/en/pc-awarded-2000.png';
import enPcAwarded4000Img from '../assets/en/pc-awarded-4000.png';
import enPcAwarded8000Img from '../assets/en/pc-awarded-8000.png';
import enPcAwarded35000Img from '../assets/en/pc-awarded-35000.png';
import enPcAwarded65000Img from '../assets/en/pc-awarded-65000.png';
import enPcAwarded100000Img from '../assets/en/pc-awarded-100000.png';
import enAwardedMissedImg from '../assets/en/awarded-missed.png';
import enPcAwardedMissedImg from '../assets/en/pc-awarded-missed.png';
import choiceSuccessNvidiaImg from '../assets/choice-success-nvidia.png';
import choiceSuccessBtcImg from '../assets/choice-success-btc.png';
import choiceSuccessVoucherImg from '../assets/choice-success-voucher.png';
import choiceSuccessHsbcImg from '../assets/choice-success-hsbc.png';
import enChoiceSuccessNvidiaImg from '../assets/en/choice-success-nvidia.png';
import enChoiceSuccessBtcImg from '../assets/en/choice-success-btc.png';
import enChoiceSuccessVoucherImg from '../assets/en/choice-success-voucher.png';
import enChoiceSuccessHsbcImg from '../assets/en/choice-success-hsbc.png';
import choiceSuccessAdvancedNvidiaImg from '../assets/rewards/choice-success-advanced-nvidia.png';
import choiceSuccessAdvancedBtcImg from '../assets/rewards/choice-success-advanced-btc.png';
import choiceSuccessAdvancedHsbcImg from '../assets/rewards/choice-success-advanced-hsbc.png';
import enChoiceSuccessAdvancedNvidiaImg from '../assets/en/choice-success-advanced-nvidia.png';
import enChoiceSuccessAdvancedBtcImg from '../assets/en/choice-success-advanced-btc.png';
import enChoiceSuccessAdvancedHsbcImg from '../assets/en/choice-success-advanced-hsbc.png';
import choiceCardAdvancedNvidiaImg from '../assets/rewards/choice-card-advanced-nvidia.png';
import choiceCardAdvancedBtcImg from '../assets/rewards/choice-card-advanced-btc.png';
import choiceCardAdvancedHsbcImg from '../assets/rewards/choice-card-advanced-hsbc.png';
import enChoiceCardAdvancedNvidiaImg from '../assets/en/choice-card-advanced-nvidia.png';
import enChoiceCardAdvancedBtcImg from '../assets/en/choice-card-advanced-btc.png';
import enChoiceCardAdvancedHsbcImg from '../assets/en/choice-card-advanced-hsbc.png';
import choiceWideAdvancedNvidiaImg from '../assets/rewards/choice-wide-advanced-nvidia.png';
import choiceWideAdvancedBtcImg from '../assets/rewards/choice-wide-advanced-btc.png';
import choiceWideAdvancedHsbcImg from '../assets/rewards/choice-wide-advanced-hsbc.png';
import enChoiceWideAdvancedNvidiaImg from '../assets/en/choice-wide-advanced-nvidia.png';
import enChoiceWideAdvancedBtcImg from '../assets/en/choice-wide-advanced-btc.png';
import enChoiceWideAdvancedHsbcImg from '../assets/en/choice-wide-advanced-hsbc.png';
import pcChoiceWideAdvancedNvidiaImg from '../assets/rewards/pc-choice-wide-advanced-nvidia.png';
import pcChoiceWideAdvancedBtcImg from '../assets/rewards/pc-choice-wide-advanced-btc.png';
import pcChoiceWideAdvancedHsbcImg from '../assets/rewards/pc-choice-wide-advanced-hsbc.png';
import enPcChoiceWideAdvancedNvidiaImg from '../assets/en/pc-choice-wide-advanced-nvidia.png';
import enPcChoiceWideAdvancedBtcImg from '../assets/en/pc-choice-wide-advanced-btc.png';
import enPcChoiceWideAdvancedHsbcImg from '../assets/en/pc-choice-wide-advanced-hsbc.png';
import pcStickyBarImg from '../assets/rewards/pc-sticky-bar.png';
import enPcStickyBarImg from '../assets/en/pc-sticky-bar.png';
import entryBadgeImg from '../assets/rewards/entry-stack-badge.png';
import enEntryBadgeImg from '../assets/en/entry-stack-badge.png';
import pcEntryBadgeImg from '../assets/rewards/pc-entry-stack-badge.png';
import choiceComboEntryImg from '../assets/rewards/choice-combo-entry.png';
import choiceComboAdvancedImg from '../assets/rewards/choice-combo-advanced.png';
import pcChoiceComboEntryImg from '../assets/rewards/pc-choice-combo-entry.png';
import pcChoiceComboAdvancedImg from '../assets/rewards/pc-choice-combo-advanced.png';
import enChoiceComboEntryImg from '../assets/en/choice-combo-entry.png';
import enChoiceComboAdvancedImg from '../assets/en/choice-combo-advanced.png';
import enPcChoiceComboEntryImg from '../assets/en/pc-choice-combo-entry.png';
import enPcChoiceComboAdvancedImg from '../assets/en/pc-choice-combo-advanced.png';

export type AdvancedTheme = 'gold' | 'dark';
/** choice=8 万三选一；voucher=15 万起现金券卡。 */
export type AdvancedTierKind = 'voucher' | 'choice';
export type AdvancedTierId =
  | '8w'
  | '15w'
  | '40w'
  | '100w'
  | '500w'
  | '1000w'
  | '2000w';

export interface AdvancedTier {
  id: AdvancedTierId;
  /** 8 万档走三选一 UI，其余档走现金券图。 */
  kind: AdvancedTierKind;
  threshold: string;
  enThreshold: string;
  theme: AdvancedTheme;
  image: string;
  enImage: string;
  pcImage: string;
  enPcImage: string;
}

export type ChoiceComboKind = 'entry' | 'advanced';

const CHOICE_CONFIRM_IMAGES: Record<ChoiceKey, string> = {
  nvidia: choiceConfirmNvidiaImg,
  btc: choiceConfirmBtcImg,
  voucher: choiceConfirmVoucherImg,
  hsbc: choiceConfirmHsbcImg,
};

const EN_CHOICE_CONFIRM_IMAGES: Record<ChoiceKey, string> = {
  nvidia: enChoiceConfirmNvidiaImg,
  btc: enChoiceConfirmBtcImg,
  voucher: enChoiceConfirmVoucherImg,
  hsbc: enChoiceConfirmHsbcImg,
};

const CHOICE_WIDE_IMAGES: Record<ChoiceKey, string> = {
  nvidia: choiceWideNvidiaImg,
  btc: choiceWideBtcImg,
  voucher: choiceWideVoucherImg,
  hsbc: choiceWideHsbcImg,
};

const EN_CHOICE_WIDE_IMAGES: Record<ChoiceKey, string> = {
  nvidia: enChoiceWideNvidiaImg,
  btc: enChoiceWideBtcImg,
  voucher: enChoiceWideVoucherImg,
  hsbc: enChoiceWideHsbcImg,
};

export const ADVANCED_TIERS: readonly AdvancedTier[] = [
  // 进阶赏第一格：8 万三选一，与后面现金券档互斥
  {
    id: '8w',
    kind: 'choice',
    threshold: '≥$8萬',
    enThreshold: '≥$80,000',
    theme: 'gold',
    image: choiceComboAdvancedImg,
    enImage: enChoiceComboAdvancedImg,
    pcImage: pcChoiceComboAdvancedImg,
    enPcImage: enPcChoiceComboAdvancedImg,
  },
  {
    id: '15w',
    kind: 'voucher',
    threshold: '≥$15萬',
    enThreshold: '≥$150,000',
    theme: 'gold',
    image: voucher2000Img,
    enImage: enVoucher2000Img,
    pcImage: pcVoucher2000Img,
    enPcImage: enPcVoucher2000Img,
  },
  {
    id: '40w',
    kind: 'voucher',
    threshold: '≥$40萬',
    enThreshold: '≥$400,000',
    theme: 'gold',
    image: voucher4000Img,
    enImage: enVoucher4000Img,
    pcImage: pcVoucher4000Img,
    enPcImage: enPcVoucher4000Img,
  },
  {
    id: '100w',
    kind: 'voucher',
    threshold: '≥$100萬',
    enThreshold: '≥$1,000,000',
    theme: 'gold',
    image: voucher8000Img,
    enImage: enVoucher8000Img,
    pcImage: pcVoucher8000Img,
    enPcImage: enPcVoucher8000Img,
  },
  {
    id: '500w',
    kind: 'voucher',
    threshold: '≥$500萬',
    enThreshold: '≥$5,000,000',
    theme: 'gold',
    image: voucher35000Img,
    enImage: enVoucher35000Img,
    pcImage: pcVoucher35000Img,
    enPcImage: enPcVoucher35000Img,
  },
  {
    id: '1000w',
    kind: 'voucher',
    threshold: '≥$1,000萬',
    enThreshold: '≥$10,000,000',
    theme: 'dark',
    image: voucher65000Img,
    enImage: enVoucher65000Img,
    pcImage: pcVoucher65000Img,
    enPcImage: enPcVoucher65000Img,
  },
  {
    id: '2000w',
    kind: 'voucher',
    threshold: '≥$2,000萬',
    enThreshold: '≥$20,000,000',
    theme: 'dark',
    image: voucher1000000Img,
    enImage: enVoucher1000000Img,
    pcImage: pcVoucher100000Img,
    enPcImage: enPcVoucher100000Img,
  },
];

const AWARDED_IMAGES: Record<AwardedCardId, string> = {
  nvidia: awardedNvidiaImg,
  btc: awardedBtcImg,
  voucher: awardedVoucherImg,
  hsbc: awardedHsbcImg,
  'advanced-nvidia': awardedAdvancedNvidiaImg,
  'advanced-btc': awardedAdvancedBtcImg,
  'advanced-hsbc': awardedAdvancedHsbcImg,
  '2000': awarded2000Img,
  '4000': awarded4000Img,
  '8000': awarded8000Img,
  '35000': awarded35000Img,
  '65000': awarded65000Img,
  '1000000': awarded100000Img,
};

const PC_AWARDED_IMAGES: Record<AwardedCardId, string> = {
  nvidia: pcAwardedNvidiaImg,
  btc: pcAwardedBtcImg,
  voucher: pcAwardedVoucherImg,
  hsbc: pcAwardedHsbcImg,
  'advanced-nvidia': pcAwardedAdvancedNvidiaImg,
  'advanced-btc': pcAwardedAdvancedBtcImg,
  'advanced-hsbc': pcAwardedAdvancedHsbcImg,
  '2000': pcAwarded2000Img,
  '4000': pcAwarded4000Img,
  '8000': pcAwarded8000Img,
  '35000': pcAwarded35000Img,
  '65000': pcAwarded65000Img,
  '1000000': pcAwarded100000Img,
};

const EN_AWARDED_IMAGES: Record<AwardedCardId, string> = {
  nvidia: enAwardedNvidiaImg,
  btc: enAwardedBtcImg,
  voucher: enAwardedVoucherImg,
  hsbc: enAwardedHsbcImg,
  'advanced-nvidia': enAwardedAdvancedNvidiaImg,
  'advanced-btc': enAwardedAdvancedBtcImg,
  'advanced-hsbc': enAwardedAdvancedHsbcImg,
  '2000': enAwarded2000Img,
  '4000': enAwarded4000Img,
  '8000': enAwarded8000Img,
  '35000': enAwarded35000Img,
  '65000': enAwarded65000Img,
  '1000000': enAwarded100000Img,
};

const EN_PC_AWARDED_IMAGES: Record<AwardedCardId, string> = {
  nvidia: enPcAwardedNvidiaImg,
  btc: enPcAwardedBtcImg,
  voucher: enPcAwardedVoucherImg,
  hsbc: enPcAwardedHsbcImg,
  'advanced-nvidia': enPcAwardedAdvancedNvidiaImg,
  'advanced-btc': enPcAwardedAdvancedBtcImg,
  'advanced-hsbc': enPcAwardedAdvancedHsbcImg,
  '2000': enPcAwarded2000Img,
  '4000': enPcAwarded4000Img,
  '8000': enPcAwarded8000Img,
  '35000': enPcAwarded35000Img,
  '65000': enPcAwarded65000Img,
  '1000000': enPcAwarded100000Img,
};

const CHOICE_SUCCESS_IMAGES: Record<ChoiceKey, string> = {
  nvidia: choiceSuccessNvidiaImg,
  btc: choiceSuccessBtcImg,
  voucher: choiceSuccessVoucherImg,
  hsbc: choiceSuccessHsbcImg,
};

const EN_CHOICE_SUCCESS_IMAGES: Record<ChoiceKey, string> = {
  nvidia: enChoiceSuccessNvidiaImg,
  btc: enChoiceSuccessBtcImg,
  voucher: enChoiceSuccessVoucherImg,
  hsbc: enChoiceSuccessHsbcImg,
};

const ADVANCED_CHOICE_SUCCESS_IMAGES: Record<
  Exclude<ChoiceKey, 'voucher'>,
  string
> = {
  nvidia: choiceSuccessAdvancedNvidiaImg,
  btc: choiceSuccessAdvancedBtcImg,
  hsbc: choiceSuccessAdvancedHsbcImg,
};

const EN_ADVANCED_CHOICE_SUCCESS_IMAGES: Record<
  Exclude<ChoiceKey, 'voucher'>,
  string
> = {
  nvidia: enChoiceSuccessAdvancedNvidiaImg,
  btc: enChoiceSuccessAdvancedBtcImg,
  hsbc: enChoiceSuccessAdvancedHsbcImg,
};

const ADVANCED_CHOICE_CARD_IMAGES: Record<
  Exclude<ChoiceKey, 'voucher'>,
  string
> = {
  nvidia: choiceCardAdvancedNvidiaImg,
  btc: choiceCardAdvancedBtcImg,
  hsbc: choiceCardAdvancedHsbcImg,
};

const EN_ADVANCED_CHOICE_CARD_IMAGES: Record<
  Exclude<ChoiceKey, 'voucher'>,
  string
> = {
  nvidia: enChoiceCardAdvancedNvidiaImg,
  btc: enChoiceCardAdvancedBtcImg,
  hsbc: enChoiceCardAdvancedHsbcImg,
};

const ADVANCED_CHOICE_WIDE_IMAGES: Record<
  Exclude<ChoiceKey, 'voucher'>,
  string
> = {
  nvidia: choiceWideAdvancedNvidiaImg,
  btc: choiceWideAdvancedBtcImg,
  hsbc: choiceWideAdvancedHsbcImg,
};

const EN_ADVANCED_CHOICE_WIDE_IMAGES: Record<
  Exclude<ChoiceKey, 'voucher'>,
  string
> = {
  nvidia: enChoiceWideAdvancedNvidiaImg,
  btc: enChoiceWideAdvancedBtcImg,
  hsbc: enChoiceWideAdvancedHsbcImg,
};

const PC_ADVANCED_CHOICE_WIDE_IMAGES: Record<
  Exclude<ChoiceKey, 'voucher'>,
  string
> = {
  nvidia: pcChoiceWideAdvancedNvidiaImg,
  btc: pcChoiceWideAdvancedBtcImg,
  hsbc: pcChoiceWideAdvancedHsbcImg,
};

const EN_PC_ADVANCED_CHOICE_WIDE_IMAGES: Record<
  Exclude<ChoiceKey, 'voucher'>,
  string
> = {
  nvidia: enPcChoiceWideAdvancedNvidiaImg,
  btc: enPcChoiceWideAdvancedBtcImg,
  hsbc: enPcChoiceWideAdvancedHsbcImg,
};

/** 确认弹窗单卡：8 万三选一走 advanced 切图，入门赏英文走 en/。 */
export function findChoiceConfirmImage(
  key: ChoiceKey,
  isEn = false,
  isAdvanced = false,
): string {
  if (isAdvanced && key !== 'voucher') {
    return findAdvancedChoiceCardImage(key, isEn);
  }
  const table = isEn ? EN_CHOICE_CONFIRM_IMAGES : CHOICE_CONFIRM_IMAGES;
  return table[key] || table.nvidia;
}

/** 已选宽卡：8 万三选一走 $10000 切图；入门赏英文走 en/choice-wide。 */
export function findChoiceWideImage(
  key: ChoiceKey,
  isEn = false,
  isPC = false,
  isAdvanced = false,
): string {
  if (isAdvanced && key !== 'voucher') {
    if (isPC) {
      const table = isEn
        ? EN_PC_ADVANCED_CHOICE_WIDE_IMAGES
        : PC_ADVANCED_CHOICE_WIDE_IMAGES;
      return table[key] || table.nvidia;
    }
    const table = isEn
      ? EN_ADVANCED_CHOICE_WIDE_IMAGES
      : ADVANCED_CHOICE_WIDE_IMAGES;
    return table[key] || table.nvidia;
  }
  const table = isEn ? EN_CHOICE_WIDE_IMAGES : CHOICE_WIDE_IMAGES;
  return table[key] || table.nvidia;
}

/** 未选时的整图：4 选 1 / 3 选 1。PC 走 pc-choice-combo，英文走 en/。 */
export function findChoiceComboImage(
  kind: ChoiceComboKind,
  isEn = false,
  isPC = false,
): string {
  if (kind === 'advanced') {
    if (isPC) {
      return isEn ? enPcChoiceComboAdvancedImg : pcChoiceComboAdvancedImg;
    }
    return isEn ? enChoiceComboAdvancedImg : choiceComboAdvancedImg;
  }
  if (isPC) {
    return isEn ? enPcChoiceComboEntryImg : pcChoiceComboEntryImg;
  }
  return isEn ? enChoiceComboEntryImg : choiceComboEntryImg;
}

export function findAdvancedTierImage(
  tier: AdvancedTier,
  isPC = false,
  isEn = false,
): string {
  if (isPC) {
    return isEn ? tier.enPcImage : tier.pcImage;
  }
  return isEn ? tier.enImage : tier.image;
}

export function findAdvancedThreshold(
  tier: AdvancedTier,
  isEn = false,
): string {
  return isEn ? tier.enThreshold : tier.threshold;
}

/** 已获得卡列表：≥1 万含 4 选 1，8–15 万再叠加 3 选 1，≥15 万叠加最高现金券。 */
export function findAwardedImages(
  netHkdCents: number | null | undefined,
  choiceKey: ChoiceKey,
  isPC = false,
  isEn = false,
  advancedChoiceKey: AdvancedChoiceKey = DEFAULT_ADVANCED_CHOICE_KEY,
): string[] {
  const ids = resolveAwardedCardIds(
    netHkdCents,
    choiceKey,
    undefined,
    advancedChoiceKey,
  );
  if (!ids.length) {
    return [findMissedImage(isPC, isEn)];
  }
  const table = isPC
    ? isEn
      ? EN_PC_AWARDED_IMAGES
      : PC_AWARDED_IMAGES
    : isEn
      ? EN_AWARDED_IMAGES
      : AWARDED_IMAGES;
  return ids.map((id) => table[id]);
}

/** 未达标 / 未获得奖励卡。 */
export function findMissedImage(isPC = false, isEn = false): string {
  if (isPC) {
    return isEn ? enPcAwardedMissedImg : pcAwardedMissedImg;
  }
  return isEn ? enAwardedMissedImg : awardedMissedImg;
}

/** 选择成功整图：8 万三选一走 advanced，英文走 en/。 */
export function findChoiceSuccessImage(
  key: ChoiceKey,
  isEn = false,
  isAdvanced = false,
): string {
  if (isAdvanced && key !== 'voucher') {
    const table = isEn
      ? EN_ADVANCED_CHOICE_SUCCESS_IMAGES
      : ADVANCED_CHOICE_SUCCESS_IMAGES;
    return table[key] || table.nvidia;
  }
  const table = isEn ? EN_CHOICE_SUCCESS_IMAGES : CHOICE_SUCCESS_IMAGES;
  return table[key] || table.nvidia;
}

/** 8 万三选一单卡：确认弹窗 / 成功弹窗叠卡。英文走 en/。 */
export function findAdvancedChoiceCardImage(
  key: ChoiceKey,
  isEn = false,
): string {
  if (key === 'voucher') {
    return '';
  }
  const table = isEn
    ? EN_ADVANCED_CHOICE_CARD_IMAGES
    : ADVANCED_CHOICE_CARD_IMAGES;
  return table[key] || table.nvidia;
}

/** PC 吸底栏。 */
export function findPcStickyBar(isEn = false): string {
  return isEn ? enPcStickyBarImg : pcStickyBarImg;
}

/** 入门赏「可額外疊加進階賞 / Eligible for Premium Reward」标签。PC 中文走独立切图。 */
export function findEntryBadge(isEn = false, isPC = false): string {
  if (isPC && !isEn) {
    return pcEntryBadgeImg;
  }
  return isEn ? enEntryBadgeImg : entryBadgeImg;
}
